<div class="peer-listing-container">
  <!-- 1. Hero Header Section with Striped Background & Floating Groups -->
  <div class="hero-section">
    <div class="hero-stripes">
      <div class="stripe stripe-1"></div>
      <div class="stripe stripe-2"></div>
      <div class="stripe stripe-3"></div>
      <div class="stripe stripe-4"></div>
      <div class="stripe stripe-5"></div>
      <div class="stripe stripe-6"></div>
      <div class="stripe stripe-7"></div>
      <div class="stripe stripe-8"></div>
      <div class="stripe stripe-9"></div>
      <div class="stripe stripe-10"></div>
      <div class="stripe stripe-11"></div>
      <div class="stripe stripe-12"></div>
      <div class="stripe stripe-13"></div>
      <div class="stripe stripe-14"></div>
      <div class="stripe stripe-15"></div>
      <div class="stripe stripe-16"></div>
    </div>
    
    <div class="hero-inner-container">
      <div class="hero-content">
        <h1 class="hero-title">Learn from peers who got in before you</h1>
        <p class="hero-subtitle">Chat with peers from top universities and make smarter choices.</p>
      </div>

      <!-- Floating Group 42 (Left) -->
      <div class="floating-group group-40">
        <div class="image-container">
          <img src="assets/images/Group 42.png" alt="Group 42" class="group-img">
          <div class="floating-avatar-container">
            <img src="assets/images/mentor_me_3.png" alt="Avatar Left" class="floating-avatar-img">
          </div>
          <div class="bubble-text text-40">
            <span class="bubble-txt-content">If you had to apply again, would you still pick this uni?</span>
            <i class="pi pi-send bubble-send-icon"></i>
          </div>
        </div>
      </div>

      <!-- Floating Group 41 (Center Top) -->
      <div class="floating-group group-41">
        <div class="image-container">
          <img src="assets/images/Group 41.png" alt="Group 41" class="group-img">
          <div class="floating-avatar-container">
            <img src="assets/images/mentor_me_5.png" alt="Avatar Right" class="floating-avatar-img">
          </div>
          <div class="bubble-text text-41">
            <span class="bubble-txt-content">How is student life there (expenses, part-time jobs) ?</span>
            <i class="pi pi-send bubble-send-icon"></i>
          </div>
        </div>
      </div>

      <!-- Floating Group 40 (Right) -->
      <div class="floating-group group-42">
        <div class="image-container">
          <img src="assets/images/Group 40.png" alt="Group 40" class="group-img">
          <div class="floating-avatar-container">
            <img src="assets/images/mentor_me_3.png" alt="Avatar Right" class="floating-avatar-img">
          </div>
          <div class="bubble-text text-42">
            <span class="bubble-txt-content">What steps did you follow from start to getting admitted?</span>
            <i class="pi pi-send bubble-send-icon"></i>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- 2. Metrics Bar -->
  <div class="metrics-bar">
    <div class="metric-item">
      <h2 class="metric-number">{{ totalPeersCount }}</h2>
      <p class="metric-desc">Peers Available</p>
    </div>
    <div class="metric-divider"></div>
    <div class="metric-item">
      <h2 class="metric-number">{{ totalUniversitiesCount }}</h2>
      <p class="metric-desc">Universities Covered</p>
    </div>
    <div class="metric-divider"></div>
    <div class="metric-item">
      <h2 class="metric-number">{{ totalCountriesCount }}</h2>
      <p class="metric-desc">Countries Covered</p>
    </div>
  </div>

  <!-- 3. Main Workspace: Filter Sidebar + Cards Grid -->
  <div class="main-workspace-wrapper">
    <div class="main-workspace-container">
      
      <!-- Left Sidebar Filters -->
      <aside class="filters-sidebar">
        <!-- Filter Card: Country -->
        <div class="filter-card">
          <h3 class="filter-title">COUNTRY</h3>
          <ul class="filter-list">
            <li [class.active]="selectedCountry === 'All Countries'" (click)="setCountry('All Countries')">
              <span class="filter-name">
                <i class="pi pi-globe globe-icon"></i>
                All Countries
              </span>
              <span class="filter-count">{{ getCountryCount('All Countries') }}</span>
            </li>
            <li [class.active]="selectedCountry === 'United States'" (click)="setCountry('United States')">
              <span class="filter-name">
                <img src="https://flagcdn.com/w40/us.png" alt="US" class="flag-icon">
                United States
              </span>
              <span class="filter-count">{{ getCountryCount('United States') }}</span>
            </li>
            <li [class.active]="selectedCountry === 'United Kingdom'" (click)="setCountry('United Kingdom')">
              <span class="filter-name">
                <img src="https://flagcdn.com/w40/gb.png" alt="UK" class="flag-icon">
                United Kingdom
              </span>
              <span class="filter-count">{{ getCountryCount('United Kingdom') }}</span>
            </li>
            <li [class.active]="selectedCountry === 'Canada'" (click)="setCountry('Canada')">
              <span class="filter-name">
                <img src="https://flagcdn.com/w40/ca.png" alt="CA" class="flag-icon">
                Canada
              </span>
              <span class="filter-count">{{ getCountryCount('Canada') }}</span>
            </li>
            <li [class.active]="selectedCountry === 'Australia'" (click)="setCountry('Australia')">
              <span class="filter-name">
                <img src="https://flagcdn.com/w40/au.png" alt="AU" class="flag-icon">
                Australia
              </span>
              <span class="filter-count">{{ getCountryCount('Australia') }}</span>
            </li>
            <li [class.active]="selectedCountry === 'Germany'" (click)="setCountry('Germany')">
              <span class="filter-name">
                <img src="https://flagcdn.com/w40/de.png" alt="DE" class="flag-icon">
                Germany
              </span>
              <span class="filter-count">{{ getCountryCount('Germany') }}</span>
            </li>
            <li [class.active]="selectedCountry === 'Singapore'" (click)="setCountry('Singapore')">
              <span class="filter-name">
                <img src="https://flagcdn.com/w40/sg.png" alt="SG" class="flag-icon">
                Singapore
              </span>
              <span class="filter-count">{{ getCountryCount('Singapore') }}</span>
            </li>
          </ul>
        </div>

        <!-- Filter Card: Board / Curriculum -->
        <div class="filter-card mt-4">
          <h3 class="filter-title">BOARD / CURRICULUM</h3>
          <ul class="filter-list">
            <li [class.active]="selectedBoard === 'All Boards'" (click)="setBoard('All Boards')">
              <span class="filter-name">All Boards</span>
              <span class="filter-count">{{ getBoardCount('All Boards') }}</span>
            </li>
            <li [class.active]="selectedBoard === 'CBSE'" (click)="setBoard('CBSE')">
              <span class="filter-name">CBSE</span>
              <span class="filter-count">{{ getBoardCount('CBSE') }}</span>
            </li>
            <li [class.active]="selectedBoard === 'ISC / ICSE'" (click)="setBoard('ISC / ICSE')">
              <span class="filter-name">ISC / ICSE</span>
              <span class="filter-count">{{ getBoardCount('ISC / ICSE') }}</span>
            </li>
            <li [class.active]="selectedBoard === 'IB'" (click)="setBoard('IB')">
              <span class="filter-name">IB</span>
              <span class="filter-count">{{ getBoardCount('IB') }}</span>
            </li>
            <li [class.active]="selectedBoard === 'A-Levels'" (click)="setBoard('A-Levels')">
              <span class="filter-name">A-Levels</span>
              <span class="filter-count">{{ getBoardCount('A-Levels') }}</span>
            </li>
            <li [class.active]="selectedBoard === 'STATE BOARD'" (click)="setBoard('STATE BOARD')">
              <span class="filter-name">STATE BOARD</span>
              <span class="filter-count">{{ getBoardCount('STATE BOARD') }}</span>
            </li>
          </ul>
        </div>

        <!-- Filter Card: I'm Targeting -->
        <div class="filter-card mt-4">
          <h3 class="filter-title">I'M TARGETING</h3>
          <ul class="filter-list">
            <li [class.active]="selectedTarget === 'All peers'" (click)="setTarget('All peers')">
              <span class="filter-name">All peers</span>
              <span class="filter-count">{{ getTargetCount('All peers') }}</span>
            </li>
            <li [class.active]="selectedTarget === 'Undergraduate'" (click)="setTarget('Undergraduate')">
              <span class="filter-name">Undergraduate</span>
              <span class="filter-count">{{ getTargetCount('Undergraduate') }}</span>
            </li>
            <li [class.active]="selectedTarget === 'Graduate / Masters'" (click)="setTarget('Graduate / Masters')">
              <span class="filter-name">Graduate / Masters</span>
              <span class="filter-count">{{ getTargetCount('Graduate / Masters') }}</span>
            </li>
            <li [class.active]="selectedTarget === 'MBA'" (click)="setTarget('MBA')">
              <span class="filter-name">MBA</span>
              <span class="filter-count">{{ getTargetCount('MBA') }}</span>
            </li>
            <li [class.active]="selectedTarget === 'STEM'" (click)="setTarget('STEM')">
              <span class="filter-name">STEM</span>
              <span class="filter-count">{{ getTargetCount('STEM') }}</span>
            </li>
          </ul>
        </div>
      </aside>

      <!-- Right Panel: Search bar & Cards Grid -->
      <main class="results-area">
        <!-- Search bar -->
        <div class="search-container">
          <i class="pi pi-search search-icon"></i>
          <input type="text" 
                 class="search-input" 
                 placeholder="Search by name, university, or major..." 
                 [(ngModel)]="searchTerm" 
                 (ngModelChange)="onSearchChange()">
        </div>

        <!-- Cards Grid Area -->
        <div class="grid-container-layout">
          <!-- Skeleton Loading -->
          <ng-container *ngIf="isLoadingPeerReviewer; else loadedGridContent">
            <div *ngFor="let _ of [].constructor(6)" class="card-skeleton" style="height: 320px; box-sizing: border-box;">
              <div class="skeleton-header">
                <p-skeleton shape="circle" size="64px"></p-skeleton>
                <p-skeleton width="80px" height="24px" styleClass="ml-auto"></p-skeleton>
              </div>
              <p-skeleton width="60%" height="24px" styleClass="mt-3"></p-skeleton>
              <p-skeleton width="80%" height="18px" styleClass="mt-2"></p-skeleton>
              <p-skeleton width="90%" height="14px" styleClass="mt-2"></p-skeleton>
              <div class="skeleton-divider mt-3 mb-3"></div>
              <div class="skeleton-stats flex gap-2">
                <p-skeleton width="30%" height="40px"></p-skeleton>
                <p-skeleton width="30%" height="40px"></p-skeleton>
                <p-skeleton width="30%" height="40px"></p-skeleton>
              </div>
              <div class="skeleton-actions flex gap-2 mt-4">
                <p-skeleton width="48%" height="40px"></p-skeleton>
                <p-skeleton width="48%" height="40px"></p-skeleton>
              </div>
            </div>
          </ng-container>

          <ng-template #loadedGridContent>
            <!-- Combined Grid Items -->
            <div *ngFor="let item of combinedItems; let i = index" class="grid-item-card" style="min-width: 0; width: 100%;">
              
              <!-- 1. Strategy Call CTA Card Inlaid -->
              <ng-container *ngIf="item.isCta; else peerCardContent">
                <div class="cta-inlay-card" style="height: 320px; box-sizing: border-box; justify-content: space-between; display: flex; flex-direction: column;">
                  <div class="badge-row">
                    <span class="cta-badge">4 MONTHS MENTORSHIP AVAILABLE</span>
                  </div>
                  <h3 class="cta-card-title">Can't find your <span class="highlight-yellow">perfect match?</span></h3>
                  <p class="cta-card-desc">Browse peers all you want but if you're still unsure of your path, our counsellors will build a personalised strategy just for you.</p>
                  
                  <div class="cta-avatar-row">
                    <div class="avatar-group-overlap">
                      <img src="assets/images/avatar1.jpg" alt="A1" class="overlap-img img-1">
                      <img src="assets/images/muskaan.jpg" alt="A2" class="overlap-img img-2">
                      <img src="assets/images/samarth.jpg" alt="A3" class="overlap-img img-3">
                    </div>
                    <span class="cta-stats-text"><strong>847 students</strong> got into top universities with our help</span>
                  </div>

                  <div class="cta-action-row">
                    <button class="cta-button" (click)="showClarityCallDialog = true">Book My Strategy Call</button>
                  </div>
                </div>
              </ng-container>

              <!-- 2. Standard Peer Card -->
              <ng-template #peerCardContent>
                <div class="peer-data-card" style="height: 320px; box-sizing: border-box;">
                  <div class="peer-main-info-row" style="min-width: 0; width: 100%;">
                    <div class="peer-info-left" style="min-width: 0; flex: 1;">
                      <h3 class="peer-name">{{ getInitialsDot(item.firstName, item.lastName) }}</h3>
                      <div class="peer-university" style="min-width: 0; width: 100%; display: flex; align-items: center;" [title]="item.cardDisplay?.uniName || ''">
                        <i class="pi pi-building uni-icon"></i>
                        <span class="uni-name" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; display: block; flex: 1; font-size: 0.85rem; font-weight: 600; line-height: 1.3;">{{ item.cardDisplay?.uniName }}</span>
                      </div>
                      <p class="peer-major" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; width: 100%; margin: 0; font-size: 0.8125rem; color: #9A9FA5;" [title]="item.cardDisplay?.major || ''">{{ item.cardDisplay?.major }}</p>
                    </div>

                    <div class="peer-info-right">
                      <span class="study-level-badge" [ngClass]="{
                        'undergrad': item.cardDisplay?.tag === 'Undergrad',
                        'masters': item.cardDisplay?.tag === 'Masters',
                        'undergrad-masters': item.cardDisplay?.tag === 'Undergrad & Masters',
                        'phd': item.cardDisplay?.tag === 'PhD'
                      }">
                        {{ item.cardDisplay?.tag }}
                      </span>
                      <div class="peer-avatar-wrapper">
                        <img [src]="item.imageUrl || (item.gender === 1 ? 'assets/images/avatar3.jpg' : 'assets/images/avatar1.jpg')" alt="Avatar" class="peer-avatar-img">
                        <span class="country-flag-badge">
                          <img [src]="item.cardDisplay?.flagUrl || 'https://flagcdn.com/w40/in.png'" alt="Flag">
                        </span>
                      </div>
                    </div>
                  </div>

                  <hr class="card-divider">

                  <!-- Stats grid inside card -->
                  <div class="card-stats-grid" style="min-width: 0;">
                    <div class="stat-col" style="min-width: 0;">
                      <span class="stat-label">{{ (item.cardDisplay?.tag === 'Masters' || item.cardDisplay?.tag === 'Undergrad & Masters') ? 'GRE' : 'SAT' }}</span>
                      <span class="stat-value" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; width: 100%; text-align: center; display: block; box-sizing: border-box;" [title]="((item.cardDisplay?.tag === 'Masters' || item.cardDisplay?.tag === 'Undergrad & Masters') ? item.greScore : item.satOverallScore) || 'N/A'">{{ ((item.cardDisplay?.tag === 'Masters' || item.cardDisplay?.tag === 'Undergrad & Masters') ? item.greScore : item.satOverallScore) || 'N/A' }}</span>
                    </div>
                    <div class="stat-col" style="min-width: 0;">
                      <span class="stat-label">12</span>
                      <span class="stat-value" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; width: 100%; text-align: center; display: block; box-sizing: border-box;" [title]="item.twelvethGrades || 'N/A'">{{ item.twelvethGrades || 'N/A' }}</span>
                    </div>
                    <div class="stat-col" style="min-width: 0;">
                      <span class="stat-label">CGPA</span>
                      <span class="stat-value" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; width: 100%; text-align: center; display: block; box-sizing: border-box;" [title]="item.underGraduateExpectedGrades || 'N/A'">{{ item.underGraduateExpectedGrades || 'N/A' }}</span>
                    </div>
                  </div>

                  <!-- Buttons Row -->
                  <div class="card-buttons-row">
                    <a [routerLink]="['/portal', 'schedule-peer-call', item.applicationUserId]" class="btn-connect">Connect</a>
                    <a [routerLink]="['/portal', 'peer-profile', item.applicationUserId]" class="btn-view-profile">View Profile</a>
                  </div>
                </div>
              </ng-template>

            </div>

            <!-- Empty State -->
            <div *ngIf="peerReviewers && peerReviewers.length === 0" class="no-data-found-container">
              <img src="../../../assets/icons/nodatafound.svg" alt="No data" class="no-data-img">
              <h4 class="no-data-title">No matching peers found</h4>
              <p class="no-data-desc">Try clearing some filters or searching for another university or major.</p>
            </div>
          </ng-template>
        </div>

        <!-- Pagination Bar -->
        <div class="pagination-container" *ngIf="totalPages > 1">
          <button class="pagination-arrow-btn" 
                  [disabled]="currentPage === 1" 
                  (click)="getPeers(currentPage - 1)">
            <i class="pi pi-chevron-left"></i>
          </button>
          
          <div class="pagination-pages">
            <button *ngFor="let page of pages" 
                    class="page-num-btn" 
                    [class.active]="currentPage === page" 
                    (click)="getPeers(page)">
              {{ page }}
            </button>
          </div>

          <button class="pagination-arrow-btn" 
                  [disabled]="currentPage === totalPages" 
                  (click)="getPeers(currentPage + 1)">
            <i class="pi pi-chevron-right"></i>
          </button>
        </div>

      </main>

    </div>
  </div>

  <!-- 4. Bottom Promotional CTA Banner -->
  <div class="bottom-promotional-banner-wrapper">
    <div class="bottom-promotional-banner">
      <div class="banner-left-art">
        <img src="assets/images/Group 716.png" alt="Illustration" class="banner-art-img">
      </div>
      
      <div class="banner-mid-text">
        <h3 class="banner-title">Can't find your <span class="highlight-yellow">perfect match?</span></h3>
        <p class="banner-desc">Browse peers all you want but if you're still unsure of your path, our counsellors will build a personalised strategy just for you.</p>
        
        <div class="banner-avatars-row">
          <div class="avatar-group-overlap">
            <img src="assets/images/avatar1.jpg" alt="A1" class="overlap-img img-1">
            <img src="assets/images/muskaan.jpg" alt="A2" class="overlap-img img-2">
            <img src="assets/images/samarth.jpg" alt="A3" class="overlap-img img-3">
          </div>
          <span class="banner-stats-text"><strong>847 students</strong> got into top universities with our help</span>
        </div>
      </div>

      <div class="banner-right-action">
        <button class="banner-cta-btn" (click)="showClarityCallDialog = true">Book My Strategy Call</button>
      </div>
    </div>
  </div>

  <!-- 5. Collapsible FAQ Accordion Section -->
  <div class="faq-accordion-section">
    <div class="faq-container">
      <h2 class="faq-title">Questions about your Peer?</h2>
      <h3 class="faq-subtitle">We have answers!</h3>

      <div class="accordion-list">
        <div *ngFor="let faq of faqs; let idx = index" class="accordion-item" [class.open]="activeFaqIndex === idx">
          <div class="accordion-header" (click)="toggleFaq(idx)">
            <span class="faq-question">{{ faq.question }}</span>
            <span class="faq-toggle-icon">
              <i class="pi" [ngClass]="activeFaqIndex === idx ? 'pi-minus' : 'pi-plus'"></i>
            </span>
          </div>
          <div class="accordion-body-collapse" [style.maxHeight]="activeFaqIndex === idx ? '300px' : '0'">
            <div class="accordion-answer-content">
              <p>{{ faq.answer }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Peers Strategy Call Dialog — shared reusable component -->
  <app-clarity-call-popup
    [(visible)]="showClarityCallDialog"
    [contactPurpose]="ContactPurpose.PeersClarityCall">
  </app-clarity-call-popup>

</div>
